

<button class="btn mx-1 btn-outline-primary border-0"  *ngIf= 'cs.enable("btnMap", "btnMap")' (click)= 'cs.navigate("admin","cfg/btnMap/123541/section/" + section)'
>btnmap-{{section}}</button>